import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadSprinterImages";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-sprinter/")({
  head: () => routeHead("/admin/upload-sprinter/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
